import React from 'react';
import { Button, Text, View } from "../../Components/Themed";
import type { CategoryProps, LeaderProps, PublicPlayerProps } from '../../types';
import { Image } from 'react-native';
import { useColors } from '../../constants/useColors';
import { LeadersHelpers } from '../api';
import moment from 'moment-mini';

type LeaderCardProps = {
    leader:LeaderProps,
    player:PublicPlayerProps,
    category:CategoryProps,
    direction?:'horizontal'|'vertical'
    show_view_profile?:boolean,
    onSelectLeader:(leader:LeaderProps, player:PublicPlayerProps) => void
}
const LeaderCard = ({ direction, leader, player, category, show_view_profile, onSelectLeader }:LeaderCardProps) => {
    const Colors = useColors();
    if(direction == 'vertical'){
        return (
            <Button float style={{ padding:0, borderRadius:12 }} onPress={() => onSelectLeader(leader, player)}>
                <View type='header' style={{ padding:5, borderTopRightRadius:12, borderTopLeftRadius:12 }}>
                    <Text theme='h1' textAlign='center' color={Colors.text.success}>{LeadersHelpers.formatPlace(leader.place)}</Text>
                </View>
                <View float style={{ borderRadius:100, padding:2, alignSelf:'center', margin:5 }}>
                    <Image
                        source={{ uri: player.profile_pic && player.profile_pic != '' ? player.profile_pic : 'https://res.cloudinary.com/hoabts6mc/image/upload/v1722453927/default_man_n96ofq.webp' }}
                        style={{ height:60, width:60, borderRadius:100 }}
                        resizeMode='cover'
                    />
                </View>
                <View transparent style={{ padding:10, borderTopWidth:1, borderColor:Colors.borders.light, borderBottomRightRadius:12, borderBottomLeftRadius:12 }}>
                    <Text theme='h2' textAlign='center' color={Colors.text.action}>{category.stat_label_loc == 'prefix'?category.stat_label:''}{leader.category_score.toFixed(2)}{category.stat_label_loc == 'suffix'?category.stat_label:''}</Text>
                </View>
            </Button>
        )
    }
    return (
        <Button float style={{ flexDirection:'row', alignItems:'center', padding:4, borderRadius:100, borderTopLeftRadius:8, borderBottomLeftRadius:8 }} onPress={() => onSelectLeader(leader, player)}>
            <View  transparent style={{ padding:5, borderRightWidth:1, borderColor:Colors.borders.light }}>
                <Text theme='h1' color={Colors.text.success}>{LeadersHelpers.formatPlace(leader.place)}</Text>
            </View>
            <View float style={{ borderRadius:100, padding:2, marginLeft:5 }}>
                <Image
                    source={{ uri: player.profile_pic && player.profile_pic != '' ? player.profile_pic : 'https://res.cloudinary.com/hoabts6mc/image/upload/v1722453927/default_man_n96ofq.webp' }}
                    style={{ height:45, width:45, borderRadius:100 }}
                    resizeMode='cover'
                />
            </View>
            <View transparent style={{ flex:1, marginLeft:10 }}>
                <Text theme='h2'>@{player.username}</Text>
                <Text style={{ marginTop:4 }} theme='description'>Joined {moment(player.create_datetime).fromNow()}</Text>
            </View>
            {show_view_profile ?
            <Button
                disabled
                title='View'
                onPress={() => console.log('')}
                type='action'
                style={{ padding:10, marginRight:10 }}
            />
            :
            <View transparent style={{ padding:5 }}>
                <Text theme='h2' color={Colors.text.action}>{category.stat_label_loc == 'prefix'?category.stat_label:''}{leader.category_score.toFixed(2)}{category.stat_label_loc == 'suffix'?category.stat_label:''}</Text>
            </View>
            }
        </Button>
    )
}

export default LeaderCard